

import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';
class EndeksBildirimBasvuruAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "EndeskBasvuruSave";
    super(baseUrl);
  }


  saveEndeksBildirimBasvuruSave(request: EndeksBasvuruSaveRequest){
    
  
    return this.post("", request, false);
   
  }

}
export default new EndeksBildirimBasvuruAPI();
class EndeksBasvuruSaveRequest {
    basvuruTuruId: number;
    sicilKodu: number;
    aboneNo: number;
    sonEndeks: number;
    captchaToken?: string;

    constructor(basvuruTuruId: number, sicilKodu: number, aboneNo: number, sonEndeks: number, captchaToken?: string) {
        this.basvuruTuruId = basvuruTuruId;
        this.sicilKodu = sicilKodu;
        this.aboneNo = aboneNo;
        this.sonEndeks = sonEndeks;
        this.captchaToken = captchaToken;
    }
}
export { EndeksBasvuruSaveRequest };
